export default __webpack_public_path__ + "static/media/book.a5e7518f.svg";